import { useTranslation } from 'react-i18next'

import { Heading } from '@ps/ds/components/primitives/Heading/Heading'
import { Separator } from '@ps/ds/components/primitives/Separator/Separator'
import { useSeoMeta } from '@unhead/react'
import { NS } from 'src/constants/i18n'

import { TermsOfService } from './TermsOfService'

export const ServiceTrackingPage = () => {
  const { t } = useTranslation(NS.TRACKING)
  useSeoMeta({ title: t('meta.title'), robots: 'noindex, nofollow' })

  return (
    <div className="flex flex-col gap-8">
      <Heading as="h1" size="xl" weight="bold" className="sm:text-4xl">
        {t('title')}
      </Heading>

      <div className="md:grid md:gap-24 md:grid-cols-[1fr_minmax(auto,380px)]">
        <div className="flex flex-col gap-8">
          <Separator />
          <TermsOfService />
        </div>
      </div>
    </div>
  )
}
